import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { AyudantiaInvestigacion, VoidAyudantiaInvestigacion } from "../interfaces/ayudantias/AyudantiaInvestigacion";
import { AyudTesisPeriodoDTO } from "../interfaces/ayudantias/AyudTesisPeriodo";
import { TblDecInvProyectoAyud } from "../interfaces/ayudantias/TblDecInvProyectoAyud";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/Ayudantia';

export default class AyudantiaService {
    //api/Ayudantia/GetFechaAperturaCierreAyudTesis
    async GetFechaAperturaCierreAyudTesis(token: any): Promise<ResponceApi<AyudTesisPeriodoDTO>> {
        const response1: AxiosResponse<ResponceApi<AyudTesisPeriodoDTO>> = await axios.get(localBack + APICATALOGO + '/GetFechaAperturaCierreAyudTesis',
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    //api/Ayudantia/ListSolicitudesAyudantiasByPeriodo/{termino}&{anio}
    async ListSolicitudesByPeriodo(token: any, termino: string, anio: string): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/ListSolicitudesByPeriodo/' + termino + '&' + anio,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    //api/Ayudantia/ListSolicitudesAyudantiasByProyecto/{id}
    async ListSolicitudesAyudantiasByProyecto(token: any, id: number): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/ListSolicitudesAyudantiasByProyecto/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    //GetSolicitudAyudantiaById
    async GetSolicitudAyudantiaById(token: any, id: number): Promise<ResponceApi<AyudantiaInvestigacion>> {
        const response1: AxiosResponse<ResponceApi<AyudantiaInvestigacion>> = await axios.get(localBack + APICATALOGO + '/GetSolicitudAyudantiaById/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    async PostSolicitudAyudantiaInvById(token: any, data: AyudantiaInvestigacion): Promise<ResponceApi<AyudantiaInvestigacion>> {
        try {
            const response: AxiosResponse<ResponceApi<AyudantiaInvestigacion>> = await axios.post(localBack + APICATALOGO + '/PostSolicitudAyudantiaInvById', data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response.data;
        } catch (error) {
            console.log('error: ' + error);
            return {
                status: { isSuccessfully: false, messages: ['Error en PostSolicitudAyudantiaInvById'] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: VoidAyudantiaInvestigacion(),
                listData: []
            }
        }
    }
    async UpdateSolicitudAyudantiaInvById(token: any, data: AyudantiaInvestigacion): Promise<ResponceApi<AyudantiaInvestigacion>> {
        try {
            const response: AxiosResponse<ResponceApi<AyudantiaInvestigacion>> = await axios.post(localBack + APICATALOGO + '/UpdateSolicitudAyudantiaInvById', data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response.data;
        } catch (error) {
            console.log('error: ' + error);
            return {
                status: { isSuccessfully: false, messages: ['Error en UpdateSolicitudAyudantiaInvById'] },
                statusCode: 500,
                count: 0,
                operation: 0,
                data: VoidAyudantiaInvestigacion(),
                listData: []
            }
        }
    }
    async DeleteSolicitudAyudantiaInvById(idproyectoayud: number, token: any): Promise<ResponceApi<TblDecInvProyectoAyud>> {
        try {
          // var formData = new FormData();
          const response: AxiosResponse<ResponceApi<TblDecInvProyectoAyud>> = await axios.delete(
            localBack + APICATALOGO + '/DeleteSolicitudAyudantiaInvById/' + idproyectoayud,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data) {
            let resp = response.data;
            //console.log(resp.strEstado);
            return resp;
          } else {
            throw new Error('No se recibieron datos válidos.');
          }
        } catch (error) {
          console.error('Error al enviar la solicitud:', error);
          throw error; // Re-lanzar el error para que se maneje donde se llama a la función
        }
    }
}